module.exports = __webpack_public_path__ + "static/media/b2.bee106f9.jpg";